import { InputCurrency } from "@sellar-io/components";
import type { PriceTierListResponseType } from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { InputContainer } from "@sellar-io/components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../../components/table/TableLegacy";
import { usePriceFormat } from "../../../../hooks/usePriceFormat";
import { priceTierItemsType } from "./ProductItemDialogPricing";

const handleUpdateItems = (
  priceTierItems: priceTierItemsType | undefined,
  ProductId: number,
  PriceTierId: number,
  price: number,
) => {
  if (price < 0) return priceTierItems;

  const item = {
    ProductId,
    basePrice: null,
    price,
    PriceTierId,
    active: true,
    discountable: true,
  };

  if (!priceTierItems?.length) return [item];

  const filteredPriceTierItems = priceTierItems.filter(
    (item) => item.PriceTierId !== PriceTierId,
  );

  if (price > 0) {
    filteredPriceTierItems.push(item);
  }

  return filteredPriceTierItems;
};
export default function ProductItemDialogPricingTableRow({
  priceTier,
  productId,
  updatedPriceTierItems,
  setUpdatedPriceTierItems,
  warning,
}: {
  productId: number;
  priceTier: PriceTierListResponseType[number];
  setUpdatedPriceTierItems: (item: priceTierItemsType | undefined) => void;
  updatedPriceTierItems: priceTierItemsType | undefined;
  warning: boolean;
}) {
  const priceFormat = usePriceFormat();

  return (
    <TableLegacyTR>
      <TableLegacyTD>{priceTier.name}</TableLegacyTD>
      <TableLegacyTD>
        <InputContainer
          className={twMerge(
            "w-[16ch]",
            warning &&
              !updatedPriceTierItems?.length &&
              "shadow-[0_0px_8px_0_rgba(249,115,22,0.75)]",
          )}
        >
          <InputCurrency
            showPrefix
            allowNegative
            placeholder="No price"
            value={priceFormat.inputFormat}
            onChange={(e) => {
              priceFormat.setInputFormat(e.target.value);
              setUpdatedPriceTierItems(
                handleUpdateItems(
                  updatedPriceTierItems,
                  productId,
                  priceTier.id,
                  parseFloat(e.target.value) * 100,
                ),
              );
            }}
          />
        </InputContainer>
      </TableLegacyTD>
    </TableLegacyTR>
  );
}
